import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Email(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Email", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38.3702 41.369H9.63909c-.8999 0-1.62932-.7294-1.62932-1.6294V21.8184c0-.8999.72942-1.6294 1.62932-1.6294H38.3702c.8999 0 1.6294.7295 1.6294 1.6294v17.9212c0 .9-.7295 1.6294-1.6294 1.6294Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38.3702 20.1895H9.63909c-.8999 0-1.62932.7295-1.62932 1.6293v.1391l9.38753 8.8013c.5242.4915.5192 1.3252-.0111 1.8102l-8.9897 8.2232c.29889.3525.74432.5768 1.24259.5768H38.3702c.4984 0 .9438-.2243 1.2427-.5768l-8.8992-8.1403c-.5267-.4818-.5359-1.3086-.0199-1.802l9.3059-8.8988v-.1328c-.0001-.8998-.7296-1.6292-1.6295-1.6292Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38.3715 20.1892H9.64043c-.38297.0004-.75374-.1347-1.04668-.3814L22.101 7.37419c1.0767-.99111 2.7333-.99111 3.81 0L39.4182 19.8078c-.2929.2467-.6637.3818-1.0467.3814Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.00985 21.8187s-.15229-1.4748.6853-2.1052l1.26836.0945v1.7317l-1.95366.279Zm31.97895 0s.1523-1.4748-.6853-2.1052l-1.2684.0945v1.7317l1.9537.279Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36.6255 13.9392H11.386c-1.075 0-1.94641.8714-1.94641 1.9464v5.0377l9.06051 8.3535c.2939.2709.6789.4213 1.0785.4213h8.8544c.3995 0 .7846-.1505 1.0785-.4213l9.0605-8.3535v-5.0377c0-1.075-.8714-1.9464-1.9465-1.9464Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M31.5339 23.3921H15.3994V21.257h16.1345c.5895 0 1.0675.4779 1.0675 1.0676-.0001.5895-.478 1.0675-1.0675 1.0675Zm-7.1083-4.2702h-9.0262v-2.1351h9.0262c.5897 0 1.0676.478 1.0676 1.0675 0 .5897-.4779 1.0676-1.0676 1.0676Z",
        fill: theme.vars.palette.primary.light
      }
    )
  ] });
}
Email.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Email"
};
validateTidalLicense();
export {
  Email
};
//# sourceMappingURL=Email.js.map
